module.exports = __webpack_public_path__ + "static/media/expactJP.c2252767.png";